import React from 'react';
import { useIntl } from 'react-intl';

import { ArrowClockwise } from '@xsolla/ui-icons';

import { HTMLEditorViewModeButton, HTMLModeLabel, ViewModeLabel } from './styleViewModeButton';

type Props = {
  onClick: () => unknown;
  isPreview: boolean;
};

export const ViewModeButton = ({ onClick, isPreview }: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <HTMLEditorViewModeButton
      onClick={onClick}
      look="link"
      palette="brand"
      size="sm"
      data-test-id="html-editor_view-mode_button">
      <ViewModeLabel isViewMode={isPreview} data-test-id="html-editor_view-mode_preview">
        {intl.messages['widget-customization.settings.bar.select-mode']}
      </ViewModeLabel>
      <ArrowClockwise />
      <HTMLModeLabel isViewMode={isPreview} data-test-id="html-editor_view-mode_html">
        HTML
      </HTMLModeLabel>
    </HTMLEditorViewModeButton>
  );
};
